import { useAuth } from "../../services/authService";
import { Navigate } from "react-router-dom";

// === Route guard that restricts access to authenticated users only ===
// If user is not logged in, redirects to the login page.
export default function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  if (!currentUser) return <Navigate to="/login" />;
  return children;
}
